{
  "view": {
    "title": "Pysäköintipaikat",
    "parkingSpot": "Pysäköintipaikka",
    "reserve": "Varaa",
    "details": "Tiedot",
    "parkingArea": "Pysäköintialue",
    "description": "Täällä voit tarkastella pysäköintipaikkoja ja varata oman pysäköintipaikan klikkaamalla haluamaasi paikkaa.",
    "queueDescription": "Varattuja paikkoja voi jonottaa.",
    "reservationsNotSet": "Pysäköintipaikkojen varaamista ei ole asetettu tälle kohteelle.",
    "complimentaryInfo": "Sinulla on {{count}} maksutonta pysäköintipaikkaa käytettävissä.",
    "disabledReservationInfo": "Invapaikat varataan asiakaspalvelun kautta.",
    "limitReached": "Olet varannut enimmäismäärän ({{max}}) pysäköintipaikkoja.",
    "noParkingAreas": "Ei saatavilla olevia pysäköintialueita"
  },
  "legend": {
    "available": "Vapaa",
    "reservedOrInactive": "Varattu",
    "mine": "Oma paikka",
    "mineUpcoming": "Oma paikka alkamassa",
    "notInUse": "Ei käytössä",
    "ending": "Päättymässä",
    "starting": "Alkamassa",
    "title": "Kuvakkeiden selitykset"
  },
  "aria": {
    "availableIndicator": "Väri-indikaattori vapaalle paikalle",
    "reservedIndicator": "Väri-indikaattori varatulle paikalle",
    "mineIndicator": "Väri-indikaattori käyttäjän omalle paikalle",
    "mineUpcomingIndicator": "Väri-indikaattori pian alkavalle omalle paikalle",
    "notInUseIndicator": "Väri-indikaattori käyttämättömälle paikalle"
  },
  "price": {
    "label": "Hinta",
    "free": "Maksuton",
    "perMonth": "{{amount}} / kk",
    "fromPerMonth": "alkaen {{amount}} / kk",
    "total": "Yhteensä"
  },
  "equipment": {
    "covered": "Katos",
    "ev_charger": "Sähköauton lataus",
    "garage": "Autotalli",
    "heating_outlet": "Tolppapaikka",
    "motorbike_spot": "Moottoripyöräpaikka",
    "yard": "Piha",
    "building": "Halli",
    "disabled_spot": "Invapaikka",
    "covered_motorbike_spot": "Katos moottoripyörä",
    "covered_disabled_spot": "Katos invapaikka",
    "garage_motorbike_spot": "Autotalli moottoripyörä",
    "garage_disabled_spot": "Autotalli invapaikka",
    "building_motorbike_spot": "Halli moottoripyörä",
    "building_disabled_spot": "Halli invapaikka"
  },
  "tooltip": {
    "reservation": {
      "current": { "label": "Varaus" },
      "future": { "label": "Tuleva varaus" },
      "previous": { "label": "Edellinen varaus" }
    },
    "available": "Saatavilla",
    "openEnded": "(toistaiseksi)"
  },
  "spot": {
    "label": "Paikka",
    "status": "Status",
    "equipment": "Paikan ominaisuudet",
    "details": "Tiedot"
  },
  "success": {
    "title": "Pysäköintipaikan varaus onnistui!",
    "starts": "Varaus alkaa"
  },
  "address": {
    "at": "osoitteessa"
  },
  "effectiveFrom": "Muutos astuu voimaan",
  "acceptRules": "Hyväksyn kohteen {{address}} säännöt ja pysäköintipaikan varausehdot",
  "date": {
    "placeholder": "pp.kk.vvvv"
  },
  "error": {
    "contractMissing": "Sopimustieto puuttuu - varauksen tekeminen ei onnistu.",
    "reservationFailed": "Varauksen tekeminen epäonnistui. Yritä hetken kuluttua uudelleen.",
    "overlap": "Valittu pysäköintipaikka ei ole varattavissa. Valitse toinen paikka tai yritä myöhemmin uudelleen.",
    "terminationFailed": "Varauksen päättäminen epäonnistui. Yritä hetken kuluttua uudelleen."
  },
  "terminate": {
    "endDateLabel": "Muutos astuu voimaan",
    "endDateTooEarly": "Päättymispäivän on oltava vähintään {{date}}",
    "cta": "Päätä varaus",
    "success": "Varaus päätetty",
    "terminateTitle": "Pysäköintipaikan varaus päättyy",
    "terminateFrom": "Pysäköintipaikan {{spot}} varaus päättyy {{date}}"
  },
  "cancel": {
    "futureReservationLabel": "Varaus astuu voimaan",
    "reservationStartedOn": "Varauksen alkamispäivä {{date}}",
    "cta": "Peru varaus",
    "success": "Varaus peruutettu",
    "error": {
      "failed": "Varauksen peruminen epäonnistui. Yritä hetken kuluttua uudelleen."
    }
  },
  "queue": {
    "join": "Liity jonoon",
    "leave": "Poistu jonosta",
    "empty": "Et ole parkkipaikkajonossa.",
    "youAreWaiting": "Olet jonottamassa pysäköintipaikkaa ominaisuudella: {{features}}",
    "additionalInfoSuffix": ". {{info}}",
    "loading": "Ladataan…",
    "loadError": "Virhe ladattaessa pysäköintijonoa."
  },
  "form": {
    "fields": {
      "equipment": {
        "label": "Haettavat paikkatyypit",
        "helper": "Valitse yksi tai useampi paikkatyyppi (esim. pihapaikka, katos, sähkölataus)."
      },
      "additionalInfo": {
        "label": "Lisätiedot",
        "placeholder": "Esim. tarve lataukselle tai aikarajaus."
      }
    },
    "actions": {
      "cancel": "Peruuta",
      "join": "Liity jonoon"
    },
    "parkingSpotContractDocumentLink": "Säännöt",
    "parkingSpotTermsOfUseLink": "Varausehdot"
  },
  "errors": {
    "equipmentRequired": "Valitse vähintään yksi paikkatyyppi",
    "equipmentUnavailable": "Valittua paikkatyyppiä ei voi jonottaa, koska vastaava paikka on vapaana.",
    "joinFailed": "Liittyminen epäonnistui"
  }
}
